<div class="row">
  <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Processo telematico'"
       [valueInput]="ctxBodyFascicolo.fascicolo.flagProcessoTelematico ? 'Si' : 'No'"></div>
</div>
<ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila || ctxBodyFascicolo.fascicolo.riunito">
  <div class="row container_fieldset">
    <div class="col-sm-12">
      <fieldset class="form-group">
        <legend>Riunione dei giudizi</legend>
        <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila">
          <div labelTextInput class="col-sm-4 bloccodati"
               [typeLabel]="'text'" [labelInput]="'Capofila'"
               [valueInput]="ctxBodyFascicolo.fascicolo.capofila ? 'Si' : 'No'"></div>
        </ng-template>
        <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.riunito">
          <div labelTextInput class="col-sm-4 bloccodati"
               [typeLabel]="'text'" [labelInput]="'Riunito'"
               [valueInput]="ctxBodyFascicolo.fascicolo.riunito ? 'Si' : 'No'"></div>
        </ng-template>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
             [labelInput]="'Data riunione'"
             [valueInput]="ctxBodyFascicolo.fascicolo.dataRiunioneGiudizio"></div>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Motivo riunione'"
             [valueInput]="ctxBodyFascicolo.fascicolo.motivoRiunioneGiudizio"></div>
      </fieldset>
    </div>
  </div>
</ng-template>

<div class="row container_fieldset">
  <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Decreto ingiuntivo</legend>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Numero decreto'"
           [valueInput]="ctxBodyFascicolo.fascicolo.numDecretoIngiuntivo"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Num. registro generale'"
           [valueInput]="ctxBodyFascicolo.fascicolo.numRegistroGenerale"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data emissione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataEmissioneDecretoIngiuntivo"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data deposito'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataDepositoDecretoIngiuntivo"></div>
    </fieldset>
  </div>
</div>

<div class="row container_fieldset">
  <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Formula esecutiva</legend>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data richiesta apposizione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataRichiestaApposizione"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data apposizione formula esecutiva'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataApposizioneFormulaEsecutiva"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data rinuncia copie'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataRitiroCopie"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Cancelliere'"
           [valueInput]="ctxBodyFascicolo.fascicolo.cancelliere"></div>
    </fieldset>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
